import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./context/Authcontext";

const ProtectedRoute = ({ children,allowedRoles }) => {
  const { user, currentRole ,logout,loading} = useAuth();
   const location = useLocation();
  console.log(user, "userr");
  if(loading) return null
   if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

   if (
    allowedRoles &&
    !allowedRoles.includes(currentRole?.name)
  ) {
      console.log(allowedRoles.includes(currentRole?.name),"role logout fix",allowedRoles)
    // logout()
    return <Navigate to="/login" replace />; // or to "/unauthorized"
  }

 return children;
  // else return <Navigate to="/login" />;
  //   return user ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
